document.addEventListener('turbolinks:load', () => {
  const createPdfButton = document.getElementById('create_pdf_btn')
  if (createPdfButton) {
    createPdfButton.onclick = () => {
      window.print()
    }
  }
})
